import React from 'react';
import PillBadge from './PillBadge';

export default function RecoBadge({ variant = 'default', label }) {
  // Wrapper léger autour de PillBadge pour signaler une intention "reco"
  // (couleur cohérente avec sentimentColor) et ne pas dupliquer la logique de pills.
  return <PillBadge label={label} variant={variant} />;
}
